import { TextBoxMaxLine1Button2Center, TextBoxMaxLine1Caption3 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { $signUpFormTranslations } from './i18n'

export const SignInLink = () => {
  const formTranslations = useUnit($signUpFormTranslations)

  return (
    <>
      <TextBoxMaxLine1Caption3 title={formTranslations.redirectQuestion} />
      <a href='/sign-in'>
        <TextBoxMaxLine1Button2Center title={formTranslations.redirectLink} />
      </a>
    </>
  )
}
